import { render } from "./TrainingComparePanel.vue?vue&type=template&id=dd45e2b6&scoped=true"
import script from "./TrainingComparePanel.vue?vue&type=script&lang=js"
export * from "./TrainingComparePanel.vue?vue&type=script&lang=js"

import "./TrainingComparePanel.vue?vue&type=style&index=0&id=dd45e2b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd45e2b6"]])

export default __exports__